export default "__VITE_ASSET__E3Je96Bo__"